import React from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';
import { gray5 } from 'styles/global_defaults/colors';
import { standardSpacing, halfSpacing } from 'styles/global_defaults/scaffolding';

interface StepsProps {
  currentStep?: number;
}

const styles = css`
  .step {
    gap: ${halfSpacing}px;
  }

  .divider {
    flex: 1;
    position: relative;
    margin: 0 ${standardSpacing}px;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      border-top: 1px solid ${gray5};
      width: 100%;
      transform: translateY(-50%);
    }
  }

  .step-badge {
    width: ${standardSpacing}px;
    height: ${standardSpacing}px;
    border-radius: 50%;
    flex-shrink: 0;
  }
`;

const TOTAL_STEPS = 2;

const Steps: React.FC<StepsProps> = ({
  currentStep = 1,
}) => {
  const steps = Array.from({ length: TOTAL_STEPS }, (_, i) => ({ id: i + 1 }));

  return (
    <div
      css={styles}
      className='d-flex align-items-center border-bottom border-gray-6 py-4 px-7 my-5 w-100'
    >
      {steps.map((stepItem, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep >= stepNumber;
        const isLast = index === steps.length - 1;

        const translationKey = `STEP_${stepNumber}`;
        const stepLabel = t.INSTITUTIONS.ADVANCED_SETTINGS.LMS_INTEGRATION.MODAL.WORKDAY_LEARN[translationKey]?.()
          || `Step ${stepNumber}`;

        return (
          <React.Fragment key={stepItem.id}>
            <div className='d-flex align-items-center step' role='presentation'>
              <div
                className={`d-flex align-items-center justify-content-center step-badge text-white ${
                  isActive ? 'bg-primary' : 'bg-gray-4'
                }`}
                aria-current={isActive ? 'step' : undefined}
              >
                {stepNumber}
              </div>
              <span className='font-weight-bold'>
                {stepLabel}
              </span>
            </div>
            {!isLast && <div className='divider' />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Steps;
